<template>
  <div class="drillrow_detail">
    <div class="drillrow_detail_inner drag-noevents">
      <div
        class="d-flex f-wrap"
        style="gap: 1rem"
      >
        <div
          class="f-column"
          style="gap: 0.75rem"
        >
          <div
            class="gw_box"
            style="
              max-width: 24rem;
              --clr-box-back: var(--clr-black-2);
              --size-title: 0.875rem;
              --size-value: 1rem;
              --gap: 1rem;
            "
          >
            <div class="f-center">
              <div class="mr-2 weight_600 text-left w-100">
                {{ item.name }}
              </div>

              <div
                v-if="!item.public"
                class="mdi mdi-pencil icon_btn csst text-nowrap text-semi-larges mr-auto pa-1 line-height_1 clr-grey"
                @click="openSaveDialog"
              >
                <div
                  class="csst_content clr-white"
                  style="bottom: -1.5rem"
                >
                  {{ $t('tooltips.edit_drill_name') }}
                </div>
              </div>
            </div>
            <div
              v-if="item.description"
              class="mt-1"
            >
              {{ item.description }}
            </div>
            <div
              v-else
              class="text-medium clr-grey mt-1"
            >
              {{ $t('common.no_description') }}
            </div>
          </div>
          <div
            class="d-flex f-wrap"
            style="gap: 0.5rem"
          >
            <component
              :is="cItem.component || 'div'"
              v-for="cItem in controls"
              :key="cItem.id"
              class="gw_btn-v1 clr-white gw_btn_text"
              v-bind="cItem.props"
              @click="
                () => {
                  if (cItem.fn) {
                    cItem.fn()
                  }
                }
              "
            >
              <i
                class="mdi text-semi-large mr-1"
                :class="cItem.icon"
              ></i>
              {{ cItem.name }}
            </component>
          </div>
        </div>
        <div
          class="f-column"
          style="gap: 1rem"
        >
          <PracticeStatsMainInfo
            :items="totals.stats"
            class="gw_box"
            style="
              --clr-box-back: var(--clr-black-2);
              --size-title: 0.875rem;
              --size-value: 1rem;
              --gap: 1rem;
            "
          />
          <PracticeStatMovesChart
            class="gw_box"
            style="--clr-box-back: var(--clr-black-2)"
            :items="totals.moves"
          />
        </div>
        <div
          class="f-column"
          style="gap: 1rem"
        >
          <PracticeStatsSecondaryInfo :items="totals.mistakes" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import DrillTagRow from '@/components/Trainer/DrillManagement/DrillTagRow'
import { getPercentageOfMax } from '@/helpers/helpers'
import { getCorrectnessActionGroups } from '@/helpers/constants'
import { getTrainerScoreGroup } from '@/helpers/trainer'
import PracticeStatsMainInfo from '@/components/PracticeHandsTotals/PracticeStatsMainInfo'
import PracticeStatsSecondaryInfo from '@/components/PracticeHandsTotals/PracticeStatsSecondaryInfo'
import PracticeStatMovesChart from '@/components/PracticeHandsTotals/PracticeStatMovesChart'
import DrillTableRowControls from '@/components/DataTables/v2/tables/DrillsTable/DrillTableRowControls'
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'DrillTableRowDetail',
  components: {
    PracticeStatsMainInfo,
    PracticeStatsSecondaryInfo,
    DrillTableRowControls,
    PracticeStatMovesChart,
  },
  mixins: [float_mix, format_mix],
  props: {
    namespace: { String, required: true },
    item: Object,
  },
  data() {
    return {}
  },
  methods: {
    setSelectedDrill() {
      this.$store.commit('drills_set', { key: 'drills_selected_drill', value: this.item })
    },
    openSaveDialog() {
      this.$store.dispatch(`${this.namespace}/router_update_query`, {
        query: this.item.query,
        push: false,
        replace: false,
        saveLocally: false,
      })
      this.setSelectedDrill()
      const dialog = `save-drill-dialog_namespace-${this.namespace}_tmpNamespace-${this.namespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    play() {
      if (!this.$store.getters.hands_configure) {
        this.setSelectedDrill()
        const dialog = `trainer-restore-hand-dialog_action-startdrill`
        this.$store.dispatch('router_set_dialogs', dialog)
        return
      }
      this.$store.dispatch('drills_start_drill', { drill: this.item })
    },
  },
  computed: {
    controls() {
      const res = [
        {
          id: 'show_hands',
          name: this.$t(`btn.show_hands`),
          icon: 'mdi-cards-playing',
          component: 'router-link',
          props: {
            to: {
              name: 'PracticeHands',
              query: {
                ffph_drill: this.item.id,
                drill_name: this.item.name,
              },
            },
          },
        },
        {
          id: 'start_drill',
          name: this.$t('btn.start_drill'),
          icon: 'mdi-play',
          fn: this.play,
        },
        // { id: 'play_drill', icon: 'mdi-play', fn: ({ row }) => this.playDrill(row) },
        // { id: 'edit_name', icon: 'mdi-pencil', fn: ({ row, index, edit, trDetail }) => { trDetail.content = 'edit' } },
        // { id: 'edit_name', icon: 'mdi-pencil', fn: ({ row, index, edit }) => this.editName=true) },
        // { id: 'delete', icon: 'mdi-trash-can-outline', fn: ({ row }) => { this.deleteItem = { ...row } } },
      ].map(i => {
        const r = {
          ...i,
          name: this.$t(`btn.${i.id}`),
          fn: i.fn || function () {},
          getProps:
            i.getProps ||
            function () {
              return {}
            },
        }
        return r
      })
      return res
    },
    totals() {
      const data = this.item.totals || {}
      const groups = getCorrectnessActionGroups()

      let moves = [
        {
          name: this.$t(`practice.stats.bests`),
          id: 'best_moves_sum',
          group: groups.best_move,
        },
        {
          name: this.$t(`practice.stats.corrects`),
          id: 'correct_moves_sum',
          group: groups.correct_move,
        },
        {
          name: this.$t(`practice.stats.inaccuracy`),
          id: 'inaccuracy_moves_sum',
          group: groups.inaccuracy,
        },
        {
          name: this.$t(`practice.stats.wrongs`),
          id: 'wrong_moves_sum',
          group: groups.wrong_move,
        },
        {
          name: this.$t(`practice.stats.blunders`),
          id: 'blunder_moves_sum',
          group: groups.blunder,
        },
      ]

      const movesValues = moves.map(dd => data[dd.id])
      const max = Math.max(...movesValues)

      moves = moves.map(i => {
        const r = {
          ...i,
          value: this.numKtoM(data[i.id] || 0, 1000, 1),
          value_percent_scaled: getPercentageOfMax({
            max,
            value: data[i.id],
          }),
        }
        return r
      })
      // console.log(moves)

      const gto_score = {
        id: 'gto_score_avg',
        unit: '',
        value: this.numFixed((data.gto_score_avg || 0) * 100),
        group: getTrainerScoreGroup(data.gto_score_avg),
      }

      const stats = [
        {
          name: this.$t('common.hands'),
          value: this.numKtoM(data.total_hands || 0, 10000, 2),
        },
        {
          name: this.$t('common.moves'),
          value: this.numKtoM(data.played_moves_sum || 0, 10000, 2),
        },
        {
          name: this.$t('common.mistakes'),
          value: this.numKtoM(data.mistake_moves_sum || 0, 10000, 2),
        },
        {
          name: this.$t('common.gto_score'),
          value: gto_score.value || 0,
          unit: '%',
        },
      ]

      let mistakes = [
        {
          id: 'total_ev_loss',
          rows: [
            {
              id: 'total_ev_loss_sum',
              unit: this.$t('common.bb'),
              decimal: 1,
            },
          ],
        },
        {
          id: 'average_ev_loss',
          rows: [
            {
              id: 'total_ev_loss_avg',
              unit: this.$t('common.bb_hand'),
              decimal: 2,
            },
            {
              id: 'total_ev_loss_as_pot_avg',
              unit: this.$t('common.pot_hand'),
              decimal: 2,
              times: 100,
            },
          ],
        },
        {
          id: 'average_mistake_ev_loss',
          rows: [
            {
              id: 'total_ev_loss_mistake_avg',
              unit: this.$t('common.bb_mistake'),
              decimal: 2,
            },
            {
              id: 'total_ev_loss_as_pot_mistake_avg',
              unit: this.$t('common.pot_mistake'),
              decimal: 2,
              times: 100,
            },
          ],
        },
        {
          id: 'total_frequency_difference',
          rows: [
            {
              id: 'total_frequency_difference_avg',
              unit: this.$t('common.percent_hand'),
              decimal: 0,
              times: 100,
            },
          ],
        },
      ]

      mistakes = mistakes.map(dd => {
        const rr = {
          ...dd,
          // value: data[dd.id],
          name: this.$t(`practice.stats.${dd.id}`),
          // tooltip: this.$t(`tooltips.${dd.id}_group`),
          tooltip: this.$t(`tooltips.${dd.id}`),
          rows: dd.rows.map(ii => {
            const rrr = {
              ...ii,
              // name: this.$t(`practice.stats.${dd.id}`),
              // tooltip: this.$t(`tooltips.${dd.id
              //   .replace('__avg', '')
              //   .replace('__sum', '')}`),
              value: this.numFixed((data[ii.id] || 0) * (ii.times || 1), ii.decimal),
            }
            return rrr
          }),
        }
        return rr
      })

      const res = {
        stats,
        moves,
        mistakes,
      }
      // console.log(res)
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.drillrow_detail {
  --clr-back-detail: var(--clr-black-1-1);
  --padding-detail: 1rem;
  overflow: hidden;
  cursor: default;
  max-height: var(--detail-max-height);
  background: var(--clr-back-detail);
  transition: 0.22s;
  border-radius: 0 0 4px 4px;
  // padding: var(--padding-detail);
  &_inner {
    display: flex;
    flex-direction: column;
    // flex-wrap: wrap;
    gap: 1rem;
    padding: 1rem;
  }
}
</style>
